<template>
	<div id="myCdDialog" class="selectCompanyDept">
		<el-tooltip id="dept" class="item" effect="light" :disabled="(companyName ? false : true)" :content="companyName" placement="top">
			<el-autocomplete :size="size" :trigger-on-focus="true" :select-when-unmatched="true" clearable @clear="reset" @focus="inputFocus($event)" @blur="deptBlur" :fetch-suggestions="querySearchAsync" :readonly="inputDis" @select="handleSelect" :style="{width: myWidth}" v-model="companyName" placeholder="请选择机构组织" class="input-with-select" ref="myInput">
				<!-- <el-button slot="append" icon="el-icon-close" @click="reset"></el-button> -->
				<!--<el-button slot="append" icon="el-icon-plus" :disabled="addBtn" @click="alertDialog"></el-button> -->
			</el-autocomplete>
		</el-tooltip>
		<el-dialog :visible.sync="dialogVisible" width="500px" :before-close="handleClose" :show-close="true" center append-to-body>
			<span slot="title" class="dialog-title">
				<span style="padding-bottom: 0px; float: left;">
				<img src="../../assets/img/BlueCoral.png" height="27px"/>
        		</span> 选择组织机构
			</span>
			<el-input :autofocus="true" placeholder="输入关键字进行过滤" v-model="filterText">
			</el-input>
			<div style="height:400px;" v-loading="loading">
				<el-scrollbar style="height: 100%;">
					<el-tree class="filter-tree" :data="data2" :props="defaultProps" :check-strictly="isStrictly" show-checkbox node-key="Id" :filter-node-method="filterNode" @check-change="checkChange" highlight-current ref="companyTree">
						<span class="custom-tree-node" slot-scope="{ node, data }">
        				<span style="padding-bottom: 0px;">
        					<img v-if="data.Type==1" src="../../assets/img/机构.png" height="20px">
        					<img v-if="data.Type==2" src="../../assets/img/组织.png" height="20px">
        					{{ node.label }}
        				</span>
						</span>
					</el-tree>
				</el-scrollbar>
			</div>
			<div style="text-align: center;">
				<el-button @click="toClose">清空</el-button>
				<el-button type="primary" @click="toSure">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { GetAllCompanyExDeptTree, testQs } from '@/api/modules/basicData/organization'
	import { listToTree } from '@/api/modules/basicData/commonData'
	export default {
		name: 'selectCompanyDept',
		data() {
			return {
				companyName: '',
				dialogVisible: false,
				addBtn: false,
				inputDis: false,
				filterText: '',
				data2: [],
				dataList: [],
				editCheckId: '',
				selectedData: [],
				selectedDept: [],
				unverifiedSelectedDept: [],
				loading: false,
				myWidth: '',
				isStrictly: false,
				defaultProps: {
					id: 'Id',
					children: 'children',
					label: 'Name'
				},
				data: [],
				idArrayDefault: [],
				querySearchList: []
			};
		},
		props: {
			isRadio: Boolean,
			setWidth: {
				type: String,
				default: '250px'
			},
			userId: {
				type: String,
				default: ''
			},
			size:{
				type: String,
				default: ''
			},
			idArray: {
				type: Array,
				default: ()=>{ return this.idArrayDefault}
			},
		},
		mounted() {
			this.setEditData()
		},
		watch: {
			filterText(val) {
				this.debouncedSearch(val)
			},
			companyName(val, oldVal) {
				if(val == '') {
					this.addBtn = false
				} else {
					this.addBtn = false
				}
			},
			'idArray': {
				handler(val, oldVal) {
					if(val.length > 0) {
						if(this.dataList.length == 0) {
							GetAllCompanyExDeptTree(this.userId, '', 0).then(res => {
								this.unverifiedSelectedDept = []
								this.selectedDept = []
								res.forEach((c) => {
									for(var i = 0; i <= this.idArray.length; i++) {
										if(c.ID+"-"+c.Type == this.idArray[i]) {
											this.unverifiedSelectedDept.push(c)
											this.selectedDept.push(c)
										}
									}
								})
								this.assignmentInput()
							}).catch(res => {
								console.log('异常原因：' + res);
							})
							return false;
						} else {
							this.unverifiedSelectedDept = []
							this.selectedDept = []
							this.dataList.forEach((c) => {
								for(var i = 0; i <= this.idArray.length; i++) {
									if(c.ID+"-"+c.Type == this.idArray[i]) {
										this.unverifiedSelectedDept.push(c)
										this.selectedDept.push(c)
									}
								}
							})
						}
					} else {
						this.unverifiedSelectedDept = []
						this.selectedDept = []
					}
					this.assignmentInput()
				},
				deep: true //深度监听
			},
		},
		created() {
			var _ = require('lodash');
			this.debouncedSearch = _.debounce(this.searchTree, 1000)
			this.checkSource()
			this.setOption()
		},
		methods: {
			setEditData() {
				GetAllCompanyExDeptTree(this.userId, '', 0).then(res => {
					this.unverifiedSelectedDept = []
					this.selectedDept = []
					res.forEach((c) => {
						for(var i = 0; i <= this.idArray.length; i++) {
							if(c.ID+"-"+c.Type == this.idArray[i]) {
								this.unverifiedSelectedDept.push(c)
								this.selectedDept.push(c)
							}
						}
					})
					//this.transferValue(this.unverifiedSelectedDept)
					this.assignmentInput()
				}).catch(res => {
					console.log('异常原因：' + res);
				})
			},
			deptBlur() {
				if(!this.companyName) {
					this.reset();
				} else {
					var list = this.querySearchList.filter((a) => {
						// var name = c.Name;
						if(a.Name.indexOf(" ") > -1) {
							a.Name = a.Name.split(" ")[1];
						};
						return a.Name == this.companyName;
					})
				}
			},
			inputFocus(event) { //获得焦点时触发
				event.currentTarget.select();
			},
			reset() {
				this.addBtn = false
				this.inputDis = false
				this.companyName = ''
				this.selectedData = []
				this.selectedDept = []
				this.unverifiedSelectedDept = [] //待验证值
				this.$emit("getValue", this.selectedDept, function(str) { //传递值，无论是否验证
					console.log('清理完成')
				});
			},
			NameFormat(name) {
				name = name.split(" ");
				return name[1] + " " + name[0];
			},
			querySearchAsync(queryString, cb) {
				GetAllCompanyExDeptTree(this.userId, queryString, 1).then(res => {
					this.querySearchList = res.map((c) => {
						return {
							value: this.NameFormat(c.Name),
							Name1: c.Name1,
							Name: c.Name,
							Id: c.Id,
							ID: c.ID,
							Type: c.Type,
						}
					})
					cb(this.querySearchList)
				})
			},
			handleSelect(item) {
				//1.赋值
				//2.addBtn不可用
				//this.addBtn = false
				//this.inputDis = true
				this.unverifiedSelectedDept = []
				this.unverifiedSelectedDept.push(item)
				this.selectedDept = []
				this.selectedDept.push(item);
				this.assignmentInput();
				this.transferValue(this.unverifiedSelectedDept)
			},
			searchTree(val) {
				this.getTreeData(val)
			},
			setOption() {
				if(this.setWidth != '') {
					this.myWidth = this.setWidth
				}
			},
			checkSource() {
				if(this.isRadio == true) {
					this.isStrictly = true
				}
			},
			//实现单选
			checkChange(item, node, self) {
				if(this.isRadio == true) {
					if(node == true) { //点击未选中复选框
						this.editCheckId = item.Id;
						this.$refs.companyTree.setCheckedKeys([item.Id]);
					}
				}
			},
			alertDialog() {
				if(this.data2.length == 0) {
					this.getTreeData('')
				}
				this.dialogVisible = true
			},
			handleClose(done) {
				this.filterText = ''
				this.$refs.companyTree.setCheckedKeys([]);
				done();
			},
			open(title, message) {
				this.$alert(message, title, {
					confirmButtonText: '确定'
				});
			},
			filterNode(value, data) {
				if(!value) return true;
				return data.Name.indexOf(value) !== -1;
			},
			getTreeData(keyWord) {
				this.loading = true
				GetAllCompanyExDeptTree(this.userId, keyWord, 0).then(response => {
					this.dataList = response
					this.data2 = listToTree('Id', 'Pid', this.dataList)
					this.loading = false
				})
			},
			toSure() {
				this.companyName = ''
				this.selectedData = this.$refs.companyTree.getCheckedNodes()
				var arr = []
				if(this.isRadio == true) {
					this.unverifiedSelectedDept = []
					arr = this.fun1(this.selectedData, [])
				} else {
					arr = this.fun1(this.selectedData, this.selectedDept)
				}
				arr.forEach((c) => {
					this.unverifiedSelectedDept.push(c)
				})
				if(this.transferValue(this.unverifiedSelectedDept) == true) {
					this.assignmentInput()
					this.toClose()
					this.dialogVisible = false
				}
			},
			transferValue(unverifiedData) {
				let isValidate = true; //验证是否通过
				this.$emit("getValue", unverifiedData, function(str) { //传递值，无论是否验证
					isValidate = str;
				});
				if(isValidate) { //验证通过
					//内外公共操作一起处理
					this.selectedDept = this.unverifiedSelectedDept //最终值进行处理
					return true
				} else { //验证不通过
					this.unverifiedSelectedDept = []
					return false
				}
			},
			assignmentInput() { //input框赋值
				this.companyName = ''
				//console.info(JSON.stringify(this.selectedDept))
				this.selectedDept.forEach((c) => {
					var name = c.Name;
					if(name.indexOf(" ") > -1) {
						name = name.split(" ")[1];
					}
					this.companyName += name + ','
				})
				this.companyName = this.companyName.substring(0, this.companyName.lastIndexOf(','));
			},
			toClose() {
				this.editCheckId = ''
				this.filterText = ''
				this.$refs.companyTree.setCheckedKeys([]);
			},
			fun1(arr1, arr2) { /*arr1 传被检测对象，arr2传已存在的列表*/
				var arrRet = []
				for(var j = 0; j < arr1.length; j++) {
					var b = false
					for(var i = 0; i < arr2.length; i++) {
						if(arr1[j].Type == 1) {
							b = true;
							break;
						}
						if(arr1[j].ID == arr2[i].ID) {
							b = true;
							break;
						}
					}
					if(!b && arr1[j].Type == 2) {
						arrRet.push(arr1[j]);
					}
				}
				return arrRet;
			}
		},
		computed: {}
	}
</script>

<style scoped>
	.el-scrollbar__wrap {
		overflow-x: hidden;
	}
	
	#dept .el-button {
		padding: 12px 10px;
	}
	
	#myCdDialog .el-tree-node__expand-icon {
		font-size: 18px
	}
	
	#myCdDialog .el-tree-node__label {
		font-size: 16px;
	}
	
	#myCdDialog .custom-tree-node {
		box-sizing: border-box;
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 16px;
		height: 30px;
		line-height: 30px;
		padding-right: 8px;
	}
	
	#myCdDialog .custom-tree-node img {
		vertical-align: top;
		margin-top: 4px;
	}
	/*.el-autocomplete-suggestion .el-popper{
		width: 390px;
	}*/
	
	.selectCompanyDept .el-autocomplete-suggestion[x-placement^=bottom] {
		width: 300px !important;
	}
</style>